import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import RyeLogo from 'components/Logo';
import { useAuth } from 'providers/AuthProvider';
import { defaultLoginRedirectFlow, useQuery } from 'routes';
import config, { Routes } from 'config/constants';
import { Input } from 'components/ui/input';
import { Button } from 'components/ui/button';
import { Typography } from 'components/ui/typography';

import './style.scss';

const DEFAULT_VALUE = '';

const ResetPage = () => {
  const allQueryParams = useQuery();
  const queryRedirect = allQueryParams.get('redirect');
  const [email, setEmail] = useState(DEFAULT_VALUE);
  const { user, error, loading, sendPasswordReset } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fallback = () => {
      if (user) {
        navigate(config.routeDefaultHome);
        return;
      }
    };

    defaultLoginRedirectFlow(
      navigate,
      loading,
      user,
      queryRedirect,
      fallback,
      allQueryParams ? `?${allQueryParams}` : '',
    );
  }, [user, loading, navigate, queryRedirect, allQueryParams]);

  useEffect(() => {
    if (error) {
      alert(error);
    }
  }, [error]);

  const handleOnSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    sendPasswordReset(email);
    setEmail(DEFAULT_VALUE);
  };

  if (loading || (user && queryRedirect)) {
    return null;
  }

  return (
    <form className="reset-auth" onSubmit={handleOnSubmit}>
      <div className="reset-auth-container">
        <RyeLogo to={Routes.Login} />
        <Typography variant="h2" as="h1" className="reset-auth-header">
          Recover Password
        </Typography>

        <Input
          className="reset-auth-input"
          id="heap-input-reset-auth-email"
          placeholder="Enter Your E-mail Address"
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value.trim())}
          required
        />
        <Button type="submit" variant="secondary">
          Send Instructions
        </Button>

        <div className="reset-auth-back-link">
          <Typography variant="link" asChild>
            <Link to={Routes.Login}>Back to sign in</Link>
          </Typography>
        </div>
        <Typography variant="small" as="p" className="reset-auth-terms">
          By clicking “Continue with Google/Email” above, you acknowledge that you have read and
          understood, and agree to Rye's{' '}
          <Typography variant="link" asChild>
            <a href={config.external.terms} target="_blank" rel="noopener noreferrer">
              Terms and Conditions
            </a>
          </Typography>{' '}
          and{' '}
          <Typography variant="link" asChild>
            <a href={config.external.privacyPolicy} target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </Typography>
          .
        </Typography>
      </div>
    </form>
  );
};

export default ResetPage;
